import { Stack } from "@mui/material";

export const PageNotFound = () => {
  return (
    <Stack alignItems={"center"} justifyContent={"center"}>
      <h1>Page Not Found!</h1>
    </Stack>
  );
};
